import React from 'react';
import cx from 'classnames';
import { makeStyles } from './index';

const TABKEY = 9;

/**
 * Use `theme settings` as much as possible instead of hard-coded values.
 * More theme settings on: https://material-ui.com/customization/theming/
 */
const focusedStyles = makeStyles(
	({ palette }) => ({
		border: {
			outline: `5px auto ${palette.action.focus}`
		}
	})
);

/*
An experimental Component for creating a focus box around any component:
*/
export const FocusBox = React.memo(
	({ children, className, onFocusChange, focused:focusedProp}) => {
		const classes = focusedStyles();
		const [justclicked, setJustClicked] =  React.useState(false);
		const [tabpressed, setTabPressed] =  React.useState(false);
		const [focused, setFocus] =  React.useState(false);

		React.useEffect(() => {
			let timeoutid = 0;
			const handleClick = () => {
				if(!focused){
					setJustClicked(true);
					timeoutid = setTimeout(() => setJustClicked(false), 100);
				}
			};
			const handleKeydown = e => e.keyCode === TABKEY && setTabPressed(true);

			window.addEventListener("click", handleClick);
			window.addEventListener("keydown", handleKeydown);
			return () => {
				clearTimeout(timeoutid);
				window.removeEventListener("click", handleClick);
				window.removeEventListener("keydown", handleKeydown);
			};
		}, []); //eslint-disable-line react-hooks/exhaustive-deps

		const focusedCompiled = tabpressed && (focusedProp !== undefined ? focusedProp : focused);

		const handleFocus = () => {
			setFocus(true);
			if(onFocusChange) onFocusChange(true);
		};
		const handleBlur = () => {
			setFocus(false);
			if(onFocusChange) onFocusChange(false);
		};

		const listeners =  (!justclicked && focusedProp === undefined) ? {
			onFocus:handleFocus,
			onBlur:handleBlur
		} : {};

		return React.cloneElement(React.Children.only(children), {
			...listeners,
			className:cx(focusedCompiled && classes.border, className),
		});
	}
);